var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-md-12" }, [
      _c("strong", [_vm._v("\n      " + _vm._s(_vm.title) + "\n    ")])
    ]),
    _vm._v(" "),
    _vm.links.length
      ? _c("div", { staticClass: "col-md-12 mt-2" }, [
          _c(
            "ul",
            { staticClass: "links" },
            _vm._l(_vm.links, function(link, index) {
              return _c(
                "li",
                { key: index },
                [
                  _c("router-link-custom", {
                    attrs: {
                      to: link.to,
                      text: link.text,
                      status: link.status,
                      to_appid: link.to_appid,
                      current_appid: link.current_appid
                    }
                  })
                ],
                1
              )
            }),
            0
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.showCreateButton
      ? _c("div", { staticClass: "col-md-12 mt-2" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-light btn-create",
              on: { click: _vm.handleCreate }
            },
            [_vm._v("\n      + " + _vm._s(_vm.createButtonText) + "\n    ")]
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ac19c7b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ac19c7b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/BaseSectionDocRefLink.vue
// module id = null
// module chunks = 